"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const luxon_1 = require("luxon");
const numeral_1 = __importDefault(require("numeral"));
const classnames_1 = __importDefault(require("classnames"));
const immutable_1 = require("immutable");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const core_1 = require("companion-app-components/utils/core");
const transactions_1 = require("companion-app-components/flux/transactions");
const compose_1 = __importDefault(require("utils/compose"));
const QData_1 = __importDefault(require("components/QData"));
const AmountField_1 = require("components/QuickenControls/AmountField");
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const selectors_1 = require("data/reconcileList/selectors");
const TransactionSelectList_1 = __importDefault(require("./TransactionSelectList"));
const log = (0, core_1.getLogger)('component/ReconcileWorkspace/index.tsx');
/**
 * Presents the form to bulk edit a group of transactions
 */
const ReconcileWorkspace = (props) => {
    var _a;
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const statementEndDate = (_a = props.statementEndDate) !== null && _a !== void 0 ? _a : '';
    const round2 = (value) => Math.round(value * 100) / 100;
    const calculateState = (newReconcileInfo, newStatementEndBalance) => {
        let payments = (0, immutable_1.List)();
        let deposits = (0, immutable_1.List)();
        if (newReconcileInfo && newReconcileInfo.get('reconcileTxns')) {
            payments = newReconcileInfo.get('reconcileTxns').filter((reconcileTxn) => reconcileTxn.amount < 0);
            deposits = newReconcileInfo.get('reconcileTxns').filter((reconcileTxn) => reconcileTxn.amount >= 0);
        }
        const difference = round2(newReconcileInfo.get('clearedBalance')) - round2(newStatementEndBalance);
        return { payments, deposits, difference };
    };
    const reconcileInfo = (0, react_redux_1.useSelector)((rootState) => (0, selectors_1.getReconcileInfoForAccount)(rootState, {
        accountId: props.account.id,
        statementDate: statementEndDate,
        statementEndingBalance: props.statementEndBalance,
    }));
    const [state, setState] = (0, react_1.useState)(calculateState(reconcileInfo, props.statementEndBalance));
    const convertClearedToReconciled = (txns) => {
        if (!txns) {
            return;
        }
        const newTxns = txns.filter((txn) => txn.state === 'CLEARED').map((txn) => txn.set('state', 'RECONCILED'));
        props.qDataSaveTransactions(newTxns);
    };
    const clearAll = () => {
        const txns = reconcileInfo.get('reconcileTxns');
        const newTxns = txns.map((txn) => txn.state !== 'CLEARED' ? txn.set('state', 'CLEARED') : null).filter((txn) => txn);
        props.qDataSaveTransactions(newTxns);
    };
    const unclearAll = () => {
        const txns = reconcileInfo.get('reconcileTxns');
        const newTxns = txns.map((txn) => txn.state === 'CLEARED' ? txn.set('state', 'PENDING') : null).filter((txn) => txn);
        props.qDataSaveTransactions(newTxns);
    };
    const closeAndExit = (status) => {
        props.onClose(status);
    };
    const onKeyDown = () => {
        // TODO:: Keeping the old commented code after TS & FC migration
        // const el = document.getElementById('reconcile-payments');
        // if (el && e.key === 'ArrowRight') {
        //   el.focus();
        // }
    };
    const onSave = () => {
        // convert all cleared transactions in the window to reconciled
        // if the balance is zero.  If not, offer to make a balance adjustment
        if (state.difference === 0) {
            convertClearedToReconciled(reconcileInfo.get('reconcileTxns'));
            setTimeout(() => closeAndExit('completed'), 500);
        }
        else {
            dialogAlert('Balances do not match', 'The total of items you have marked is ' +
                `${(0, AmountField_1.formatNumber)(state.difference, props.account.currency, '0,00.00')} more than  ` +
                'the total of the items from your bank.', (ret) => {
                if (ret.btnPressed === 'Create a balance adjustment') {
                    const newBal = round2(props.statementEndBalance);
                    const balAdjustTxn = new transactions_1.transactionsTypes.CashFlowTransaction({
                        accountId: props.account.id,
                        amount: -state.difference,
                        isReviewed: true,
                        state: 'RECONCILED',
                        payee: 'Reconciliation Balance Adjustment',
                        memo: `Requested cleared balance on ${luxon_1.DateTime.fromISO(statementEndDate).toFormat('M/d/yyyy')}` +
                            ` to be ${(0, numeral_1.default)(newBal).format('0,00.00')}`,
                        postedOn: statementEndDate,
                        coa: {
                            type: 'BALANCE_ADJUSTMENT',
                            id: '0',
                        },
                    });
                    props.qDataSaveTransactions([balAdjustTxn]);
                    convertClearedToReconciled(reconcileInfo.get('rec~oncileTxns'));
                    setTimeout(() => closeAndExit('completed'), 500);
                }
            }, ['Create a balance adjustment', 'return to reconcile']);
        }
    };
    const transactionClick = (txn) => {
        const newTxn = txn.set('state', txn.state === 'CLEARED' ? 'PENDING' : 'CLEARED');
        props.qDataSaveTransactions([newTxn]);
    };
    const renderReconcile = () => {
        if (reconcileInfo && reconcileInfo.get('reconcileTxns')) {
            return (<Paper_1.default elevation={0}>
          <div className={props.classes.divFlex}>
            <TransactionSelectList_1.default onClick={transactionClick} title="Payments and Checks" transactions={state.payments} className={props.classes.txList} showTotals onKeyDown={onKeyDown} id="reconcile-payments" currencyString={props.account.currency} accountType={props.account.type}/>
            <TransactionSelectList_1.default onClick={transactionClick} title="Deposits" transactions={state.deposits} className={(0, classnames_1.default)(props.classes.txList, 'right')} showTotals onKeyDown={onKeyDown} id="reconcile-deposits" currencyString={props.account.currency} accountType={props.account.type}/>
          </div>
        </Paper_1.default>);
        }
        return [];
    };
    const renderReconcileWorkspace = () => {
        const { account, classes } = props;
        return (<>
        <Paper_1.default elevation={0} className={classes.container}>
          {renderReconcile()}
        </Paper_1.default>
        <Divider_1.default className={classes.divider}/>
        <Paper_1.default elevation={0} className={classes.buttonHolderWithTotal}>
          <div className={classes.paperReconcileWorkspace}>
            <div className={classes.divPaddingLeft20}>
              <Typography_1.default variant="subtitle2">
                Statement Ending Balance
              </Typography_1.default>
              <Typography_1.default>
                {(0, AmountField_1.formatNumber)(props.statementEndBalance, account.currency, '0,00.00')}
              </Typography_1.default>
            </div>
            <div className={classes.divPaddingLeft20}>
              <Typography_1.default variant="subtitle2">
                Cleared Balance
              </Typography_1.default>
              <Typography_1.default>
                {(0, AmountField_1.formatNumber)(reconcileInfo.get('clearedBalance'), account.currency, '0,00.00')}
              </Typography_1.default>
            </div>
            <div className={classes.divPaddingLeft20}>
              <Typography_1.default variant="subtitle2">
                Difference
              </Typography_1.default>
              <Typography_1.default>
                {(0, AmountField_1.formatNumber)(state.difference, account.currency, '0,00.00')}
              </Typography_1.default>
            </div>
            <div className={classes.markAllLabel}>
              <Typography_1.default variant="subtitle2">
                Mark all as:
              </Typography_1.default>
            </div>
            <Button_1.default className={classes.buttons} onClick={clearAll} color="primary" id="reconcile-clear-all">
              Cleared
            </Button_1.default>
            <Typography_1.default className={classes.separator}>
              |
            </Typography_1.default>
            <Button_1.default className={classes.buttons} onClick={unclearAll} color="primary" id="reconcile-unclear-all">
              Uncleared
            </Button_1.default>
          </div>
          <Button_1.default className={classes.buttons} onClick={() => closeAndExit('canceled')} color="primary" id="reconcile-cancel">
            Finish Later
          </Button_1.default>
          <Typography_1.default className={classes.separator}>
            |
          </Typography_1.default>
          <Button_1.default className={classes.buttons} onClick={onSave} name="reconcile-last-tab" color="primary" id="reconcile-save">
            Finish Reconciliation
          </Button_1.default>
        </Paper_1.default>
      </>);
    };
    const prevReconcileInfo = (0, react_use_1.usePrevious)(reconcileInfo);
    (0, react_use_1.useEffectOnce)(() => {
        log.log('Reconcile Workspace Initialize');
    });
    (0, react_1.useEffect)(() => {
        if (reconcileInfo !== prevReconcileInfo) {
            setState(calculateState(reconcileInfo, props.statementEndBalance));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reconcileInfo, prevReconcileInfo]);
    return (<Dialog_1.default classes={{ paperWidthLg: props.classes.paperWidthMd }} open maxWidth={false} onClose={() => closeAndExit('canceled')} onKeyDown={(e) => e.stopPropagation()}>
      <DialogTitle_1.default>
        {`Reconcile Transactions up to ${luxon_1.DateTime.fromISO(statementEndDate).toFormat('MM/dd/yyyy')}`}
      </DialogTitle_1.default>
      {renderReconcileWorkspace()}
    </Dialog_1.default>);
};
exports.default = (0, compose_1.default)((0, QData_1.default)())(ReconcileWorkspace);
